import { ShortBody } from 'components/Typography';
import styled from 'styled-components';

export const StyledShortBody = styled(ShortBody)`
  white-space: pre-line;
`;
